import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { setPanelSelector } from '@/state/selector/panelSelector';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { isOpenButtonCreateTicket } from '../handler/TicketListHandler';
import './ViewTabs.css';
import { isSetDefaultPanelAtom } from '@/state/atom/panelAtom';
import { Popover, Tooltip } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { I18n } from 'aws-amplify';
import { userAtom } from '@/state/atom/userAtom';
import { isShowExternalDeskRequestSystemForm } from '../handler/ExternalQaTicketHandler';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { permissionCreateTicketExternalDeskRequest, permissionCreateTicketInviteGuestDesk } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { useSnackbar } from 'notistack';
import { useOutboundCall } from '@/hooks/useOutboundCall';
import { isDisplayTelephoneViewInQAList } from './handler/ViewTabsHandler';
import PhoneSearchPopoverV2 from '@/component/common/PhoneSearchPopoverV2';
import { voiceStatusAtom } from '@/state/atom/voiceCallAtom';

function a11yProps(type) {
    return {
        id: `scrollable-auto-tab-${type}`,
        'aria-controls': `scrollable-auto-tabpanel-${type}`,
    };
}

export default function ViewTabs(props) {
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const isSetDefaultPanel = useRecoilValue(isSetDefaultPanelAtom);

    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const userDetail = useRecoilValue(userAtom);
    const [currentCorporationFormList, setCurrentCorporationFormList] = useRecoilState(
        formListOfProjectSelector
    );
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);

    const [formTypePopover, setFormTypePopover] = useState(null);
    const isOpenFormTypePopover = Boolean(formTypePopover);
    
    // Phone Search Popover state
    const [voiceStatus, setVoiceStatus] = useRecoilState(voiceStatusAtom);
    const isCannotMakeCall = useMemo(() => {
        return voiceStatus !== Constant.PHONE_AVAILABILITY.READY;
    }, [voiceStatus]);

    const [phoneSearchAnchorEl, setPhoneSearchAnchorEl] = useState(null);
    const isPhoneSearchOpen = Boolean(phoneSearchAnchorEl);
    const { enqueueSnackbar } = useSnackbar();
    
    // Voice call hook
    const { initiateCall } = useOutboundCall();

    // Outbound call project selector state (for QA list panel)
    const [selectedOutboundProject, setSelectedOutboundProject] = useState(null);

    const handleAddPanel = (e, selectedTicketType) => {
        addNewPanel( {
            type: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
            tabId: `QA_NEW_TICKET_TAB_${Date.now().toString()}`,
            props,
            selectedTicketType
        });
        setFormTypePopover(null)
    };

    const handleOptionsTicketTypeToCreate = (e) => {
        if (!isShowOptionInvite()) {
            handleAddPanel(e, Constant.QA_CREATE_TICKET_TYPE.QA);
            return;
        }
        setFormTypePopover(e.currentTarget)
    }

    const handleChangeView = (event, newValue) => {
        props.setViewSelected(newValue);
        props.setFilterTelephonePublisher('');

        switch (newValue) {
            case Constant.CUSTOMER_SIDE_VIEW.IN_CHARGE_QA_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.SENT);
                props.setFilterCreator(Constant.QA_FILTER_CREATOR.PROJECT_MEMBER);
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.DRAFT_QA_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.DRAFT);
                props.setFilterCreator(Constant.QA_FILTER_CREATOR.ME);
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.ARCHIVE_QA_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.ARCHIVE);
                props.setFilterCreator(Constant.QA_FILTER_CREATOR.ALL);
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.SENT);
                props.setFilterCreator('');
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.TELEPHONE_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.SENT);
                props.setFilterCreator('');
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            case Constant.CUSTOMER_SIDE_VIEW.INVITATION_VIEW:
                props.setFilterStatus(Constant.QA_FILTER_STATUS.SENT);
                props.setFilterCreator('');
                props.setFilterHelpDesk('');
                props.setFilterHelpDeskNotice('');
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (isSetDefaultPanel) {
            addNewPanel({
                type: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
                tabId: `QA_NEW_TICKET_TAB_${Date.now().toString()}`,
                props,
            });
        }
    }, [])

    const formExternalDeskRequestInfo = isShowExternalDeskRequestSystemForm(
        Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK,
        currentCorporationFormList,
        projectInuseDetail
    );

    const formInviteGuestDeskInfo = isShowExternalDeskRequestSystemForm(
        Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST,
        Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK,
        currentCorporationFormList,
        projectInuseDetail
    );

    const isShowOptionInvite = () => {
        return (permissionCreateTicketExternalDeskRequest(
            userDetail,
            projectInuseDetail.type,
            formExternalDeskRequestInfo.status,
            corporationDetail.contractType
        ) ||
            permissionCreateTicketInviteGuestDesk(
                userDetail,
                projectInuseDetail.type,
                formInviteGuestDeskInfo.status,
                corporationDetail.limitValue?.numOfGuestDesk,
                corporationDetail.contractType
        ))
    }

    /**
     * Handle open phone search popover or make direct call
     */
    const handleOpenPhoneSearch = async (event) => {
        // If called from QA list with selected project, make direct call
        if (selectedOutboundProject && selectedOutboundProject.phone) {
            try {
                const phoneData = {
                    phone: selectedOutboundProject.phone,
                    name: selectedOutboundProject.projectName,
                    projectId: selectedOutboundProject.projectId,
                    type: 'project',
                    callType: 'project',
                    sourcePanel: 'QA_LIST'
                };
                
                await initiateCall(phoneData);
            } catch (error) {
                console.error('Error handleOpenPhoneSearch:', error);
            }
            
        }
        
        // Otherwise, open search popover
        setPhoneSearchAnchorEl(event.currentTarget);
    };

    /**
     * Handle close phone search popover
     */
    const handleClosePhoneSearch = () => {
        setPhoneSearchAnchorEl(null);
    };


    /**
     * Validate phone number format
     * Must start with + and country code (e.g., +81, +84, +1)
     * @param {string} phoneNumber - Phone number to validate
     * @returns {boolean} - True if valid
     */
    const validatePhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return false;
        
        // Remove all spaces and hyphens for validation
        const cleanPhone = phoneNumber.replace(/[\s-]/g, '');
        
        // Must start with + followed by country code and number
        // Format: +[country code][number]
        // Example: +819012345678, +84901234567, +12025551234
        const phoneRegex = /^\+\d{10,15}$/;
        
        return phoneRegex.test(cleanPhone);
    };

    /**
     * Handle phone selection and make outbound call
     * @param {Object} phoneData - Selected phone data
     */
    const handleSelectPhone = async (phoneData) => {
        console.log('[handleSelectPhone] Selected phone:', phoneData);
        
        // Add sourcePanel for QA list
        const phoneDataWithSource = {
            ...phoneData,
            sourcePanel: 'QA_LIST'
        };
        
        const result = await initiateCall(phoneDataWithSource);
        
        if (result.success) {
            enqueueSnackbar(I18n.get('MSG-CM-SEND-TICKET-SUCCESS'), {
                variant: 'success',
                anchorOrigin: { vertical: 'top', horizontal: 'right' }
            });
        }
        
        handleClosePhoneSearch();
    };

    /**
     * Handle outbound project selection (for QA list panel)
     * @param {Object} projectData - Selected project data
     */
    const handleSelectOutboundProject = (projectData) => {
        setSelectedOutboundProject(projectData);
        
        // If project has phone number, open phone search popover
        if (projectData.phone) {
            // Create a button element to anchor the popover
            const button = document.querySelector('.btn-outbound-call-from-qa');
            if (button) {
                setPhoneSearchAnchorEl(button);
            }
        }
    };

    const handleWheel = useCallback((event) => {
        const element = event.currentTarget;
        if (!element) return;
        
        element.scrollLeft += event.deltaY > 0 ? Constant.SCROLL_LEFT_CHANGE : Constant.SCROLL_LEFT_CHANGE * -1;
        event.preventDefault();
        event.stopPropagation();
    }, []);

    const handleTouchStart = useCallback((event) => {
        const element = event.currentTarget;
        if (!element) return;
        
        element.touchStartX = event.touches[0].clientX;
        element.scrollLeftStart = element.scrollLeft;
    }, []);

    const handleTouchMove = useCallback((event) => {
        const element = event.currentTarget;
        if (!element || !element.touchStartX) return;
        
        const touchX = event.touches[0].clientX;
        const diff = element.touchStartX - touchX;
        element.scrollLeft = element.scrollLeftStart + diff;
    }, []);

    const handleTouchEnd = useCallback(() => {
        const element = document.querySelector('.tabs-wrap--qa .tabs-scroll-container');
        if (!element) return;
        
        delete element.touchStartX;
        delete element.scrollLeftStart;
    }, []);

    useEffect(() => {
        const element = document.querySelector('.tabs-wrap--qa .tabs-scroll-container');
        if (!element) return;

        // Add wheel event listener with passive: false to allow preventDefault
        element.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            element.removeEventListener('wheel', handleWheel);
        };
    }, [handleWheel]);

    return (
        <div className="tabs-info">
            <div className="tabs-wrap tabs-wrap--qa" data-cy="tabs-wrap" style={{justifyContent: 'space-between', gap:'10px'}}>
                <div 
                    className="tabs-scroll-container" 
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <div className="navTabs navTabs-qa" >
                        <AppBar className="navTabs-box" position="static">
                            <Tabs
                                className="navTabs-rot"
                                value={props.viewSelected}
                                onChange={handleChangeView}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="standard"
                                aria-label="scrollable auto tabs example"
                            >
                                <Tab
                                    data-cy="tab-internal-qa"
                                    className="navTabs--item nav-Tabs-flex"
                                    label={
                                        <OverFlowTooltipWithTabsMui value={I18n.get('CM-VIEW-NAME-IN-CHARGE-QA')}/>
                                    }
                                    value={Constant.CUSTOMER_SIDE_VIEW.IN_CHARGE_QA_VIEW}
                                    {...a11yProps('IN_CHARGE_VIEW')}
                                />
                                <Tab
                                    data-cy="tab-internal-qa"
                                    className="navTabs--item nav-Tabs-flex"
                                    label={
                                        <OverFlowTooltipWithTabsMui value={I18n.get('CM-VIEW-NAME-NOTICE')}/>
                                    }
                                    value={Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW}
                                    {...a11yProps('NOTICE_VIEW')}
                                />
                                {isDisplayTelephoneViewInQAList(userDetail, projectInuseDetail, corporationDetail) && (
                                    <Tab
                                        data-cy="tab-telephone"
                                        className="navTabs--item nav-Tabs-flex"
                                        label={
                                            <OverFlowTooltipWithTabsMui value={I18n.get('CM-VIEW-NAME-TELEPHONE')}/>
                                        }
                                        value={Constant.CUSTOMER_SIDE_VIEW.TELEPHONE_VIEW}
                                        {...a11yProps('TELEPHONE_VIEW')}
                                    />
                                )}
                                <Tab
                                    data-cy="tab-internal-qa"
                                    className="navTabs--item nav-Tabs-flex"
                                    label={
                                        <OverFlowTooltipWithTabsMui value={I18n.get('CM-VIEW-NAME-DRAFT-QA')}/>
                                    }
                                    value={Constant.CUSTOMER_SIDE_VIEW.DRAFT_QA_VIEW}
                                    {...a11yProps('DRAFT_VIEW')}
                                />
                                <Tab
                                    data-cy="tab-internal-qa"
                                    className="navTabs--item nav-Tabs-flex"
                                    label={
                                        <OverFlowTooltipWithTabsMui value={I18n.get('CM-VIEW-NAME-ARCHIVE-QA')}/>
                                    }
                                    value={Constant.CUSTOMER_SIDE_VIEW.ARCHIVE_QA_VIEW}
                                    {...a11yProps('ARCHIVE_VIEW')}
                                />
                                {projectInuseDetail?.type !== Constant.PROJECT_TYPE.BASE && (
                                    <Tab
                                        data-cy="tab-internal-qa"
                                        className="navTabs--item nav-Tabs-flex"
                                        label={
                                            <OverFlowTooltipWithTabsMui value={I18n.get('CM-VIEW-NAME-INVITATION')}/>
                                        }
                                        value={Constant.CUSTOMER_SIDE_VIEW.INVITATION_VIEW}
                                        {...a11yProps('INVITATION_VIEW')}
                                    />
                                )}
                            </Tabs>
                        </AppBar>
                    </div>
                </div>
                {props.isCreateTicket && isOpenButtonCreateTicket(userDetail, props.contractType, props.ticketListType, projectInuseDetail) && (
                    <div className="tabs-button-container">
                        <Tooltip title="新規作成">
                            <button className='btn-add-ticket'  onClick={e => handleOptionsTicketTypeToCreate(e)}>
                                <img src="/assets/image/icon-add-ticket.svg" alt="icon-add-ticket" />
                                <span className='text-add-ticket'>作成</span>
                            </button>
                        </Tooltip>
                        {Utils.shouldShowPhoneIcon(corporationDetail, projectInuseDetail, props?.ticketListType) && (
                            <Tooltip title="ボイス">
                                <button
                                    className={`btn-make-call ${isCannotMakeCall ? 'disabled' : ''}`}
                                    disabled={isCannotMakeCall}
                                    onClick={handleOpenPhoneSearch}
                                >
                                    <img src="/assets/image/voice.svg" alt="phone" />
                                </button>
                            </Tooltip>
                        )}

                        {/* Phone Search Popover */}
                        <PhoneSearchPopoverV2
                            open={isPhoneSearchOpen}
                            anchorEl={phoneSearchAnchorEl}
                            onClose={handleClosePhoneSearch}
                            onSelectPhone={handleSelectPhone}
                            onMakeCallAiTraining={() => {}}
                        />

                        <Popover
                            className="ticket-types-manager"
                            style={{ width: 'auto' }}
                            id={isOpenFormTypePopover ? 'simple-popover' : undefined}
                            open={isOpenFormTypePopover}
                            anchorEl={formTypePopover}
                            onClose={() => setFormTypePopover(null)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                            }}
                        >
                            <ul>
                               
                                <li
                                    className="active"
                                    onClick={e =>
                                        handleAddPanel(
                                            e,
                                            Constant.QA_CREATE_TICKET_TYPE.QA
                                        )
                                    }
                                >
                                    <span className="text">
                                        {I18n.get('FIELDFORMBTN007')}
                                    </span>
                                </li>
                                {isShowOptionInvite() && (
                                    <>
                                        <li
                                            onClick={e =>
                                                handleAddPanel(
                                                    e,
                                                    Constant.QA_CREATE_TICKET_TYPE.INVITATION
                                                )
                                            }
                                        >
                                            <span className="text">
                                                {I18n.get('USER04BTN009')}
                                            </span>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </Popover>
                    </div>
                )}
            </div>
        </div>
    );
}
